import React from "react";
// Styles
import classes from "./Challenges.module.scss";
// PropType
import PropTypes from "prop-types";

const Challenge = ({ image, preview, repo, title }) => {
  return (
    <div className={classes.CardOuter}>
      <div className={classes.CardInner}>
        <div className={classes.ImageContainer}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/${image}`}
            alt={title}
          />
        </div>
        <div className={classes.Info}>
          <h2 className={classes.Title}>{title}</h2>
          <div className={classes.ActionButtons}>
            <a href={repo} target='_blank' rel='noreferrer'>
              github
            </a>
            <a href={preview} target='_blank' rel='noreferrer'>
              preview
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

Challenge.propTypes = {
  image: PropTypes.string.isRequired,
  preview: PropTypes.string.isRequired,
  repo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Challenge;
